import { matchPath } from 'react-router-dom';

import {
  PATHWAYS_START_URL,
  STUDENTS_ASSIGNMENTS_LIST_URL,
  STUDENTS_URL,
  TEACHERS_HOME_URL,
  TEACHER_ASSIGNMENTS_V2_URL,
  WALKTHROUGH_ROLLOUT_URL
} from 'config/urls';
import { includes, isNull } from 'lodash';

import { SIGN_UP_ONBOARDING_STAGES } from 'pages/Walkthrough/constants';
import {
  shutdownIntercomWidget,
  updateIntercomEntity
} from 'utils/integrations/intercom';

const HOME_PAGE_ENABLED = process.env.REACT_APP_HOME_PAGE_ENABLED === 'true';

export const getRedirectPath = ({ user, nextPath, isMobile = false }) => {
  const isTeacher = user.is_teacher || user.is_superuser;
  const isStudent = !isNull(user.student_id);
  const isPathwaysUser = user.is_pathways_user;

  const isOnSignUpOnboardingFlow = includes(
    [
      SIGN_UP_ONBOARDING_STAGES.PROFILE_CREATED,
      SIGN_UP_ONBOARDING_STAGES.PROFILE_COMPLETED
    ],
    user.onboarding_stage
  );

  if (isOnSignUpOnboardingFlow) {
    return WALKTHROUGH_ROLLOUT_URL;
  }

  const studentAppMatch = matchPath(nextPath, {
    path: STUDENTS_URL,
    exact: false
  });

  if (isTeacher && isPathwaysUser) {
    return PATHWAYS_START_URL;
  }

  if (nextPath) {
    if (isTeacher && !studentAppMatch) {
      // If there is next path & the user is a teacher trying to access a /teacher route -> redirect to the next path.
      return nextPath;
    }

    if (isStudent && studentAppMatch) {
      // If there is next path & the user is a student trying to access a /student route -> redirect to the next path.
      return nextPath;
    }

    if (isTeacher && !isStudent && studentAppMatch) {
      // If there is next path & the user is a teacher, but without a demo student, trying to access a /student route -> redirect to the teachers' homepage.
      if (HOME_PAGE_ENABLED) {
        return TEACHERS_HOME_URL;
      }
      return TEACHER_ASSIGNMENTS_V2_URL;
    }

    if (isStudent && !isTeacher && !studentAppMatch) {
      // If there is next path & the user is a regular (non-teacher-demo) student, trying to access a /teacher route -> redirect to the students' homepage.
      return STUDENTS_ASSIGNMENTS_LIST_URL;
    }
  }

  // If there is no next path -> redirect to the respective user's homepage.
  if (isTeacher) {
    if (HOME_PAGE_ENABLED) {
      return TEACHERS_HOME_URL;
    }
    return TEACHER_ASSIGNMENTS_V2_URL;
  }
  return STUDENTS_ASSIGNMENTS_LIST_URL;
};

export const handleIntercomOnRedirect = (user, redirectPath) => {
  const isTeacher = user.is_teacher || user.is_superuser;
  const studentAppMatch = matchPath(redirectPath, {
    path: STUDENTS_URL,
    exact: false
  });

  if (isTeacher) {
    updateIntercomEntity(user);
  }

  if (studentAppMatch) {
    // Make sure to hide the Intercom widget if the user is being redirected to the students' app.
    shutdownIntercomWidget();
  }
};
